import { render, staticRenderFns } from "./PageBuilderSettingsModal.vue?vue&type=template&id=924e958a&scoped=true"
import script from "./PageBuilderSettingsModal.vue?vue&type=script&lang=js"
export * from "./PageBuilderSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./PageBuilderSettingsModal.vue?vue&type=style&index=0&id=924e958a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924e958a",
  null
  
)

export default component.exports